export default {
  methods: {
    /**
     * IBAN formatter that adds spaces every 4 characters for display.
     * @param {string} value - The IBAN string.
     * @returns {string} The formatted IBAN with spaces.
     */
    formatIBAN: (value) => {
      if (!value) return '';
      const cleanValue = String(value).replace(/\s/g, '');
      return cleanValue.replace(/(.{4})/g, '$1 ').trim();
    },
    revertIBAN: (value) => {
      if (!value) return '';
      return String(value).replace(/\s/g, '');
    },
  }
};
